export default __webpack_public_path__ + "static/media/house.74310422.jpeg";